import React, { useEffect, useState } from 'react';
import {
	Box,
	Container,
	Grid,
	makeStyles,
	Accordion,
	AccordionSummary,
	AccordionDetails,
	Slider,
	withStyles,
	FormControlLabel,
	Checkbox,
	Hidden,
	useMediaQuery,
	useTheme,
} from '@material-ui/core';
// import Skeleton from '@material-ui/lab/Skeleton';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import TitleText from '../../components/reusableComponents/TitleText';
import BodyText from '../../components/reusableComponents/BodyText';
import flightpro from '../../assets/images/flightpro.png';
import spice from '../../assets/images/spice.gif';
import indigo from '../../assets/images/indigo.gif';
import go_first from '../../assets/images/go_first.gif';
import air from '../../assets/images/air.jpg';
import airasia from '../../assets/images/airasia.png';
import vistara from '../../assets/images/vistara.jpg';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import InfiniteScroll from 'react-infinite-scroll-component';
import FlightDetailModal from '../../components/reusableComponents/FlightDetailModal';
// import Home from '../../assets/images/ONEWAY.jpg';
import Home from '../../assets/images/j10.jpg';
import h1 from '../../assets/images/h1.png';
import h2 from '../../assets/images/h2.jpg';
import h3 from '../../assets/images/h3.png';
import h4 from '../../assets/images/h4.png';
import h5 from '../../assets/images/h5.png';
import flightrun from '../../assets/images/flightrun.png';

import { setFlightId, toggleFlightModal } from '../../reducers/UiReducer';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { useDispatch, useSelector } from 'react-redux';
import WbSunnyIcon from '@material-ui/icons/WbSunny';
import { useHistory, useLocation } from 'react-router-dom';
import { SearchFormDispatch } from '../../reducers/HomeReducer';
import Drawers from '../../components/Drawers';
import Login from '../../components/reusableComponents/Login';
import OnewayForm from '../../form/OneWayFlightForm';
import {
	FlightFareRuleDispatch,
	FlightFareRuleEtravDispatch,
} from '../../reducers/HomeReducer';
import flightnotfound from '../../assets/images/flightnotfound.png';
import HeaderSection from '../../components/reusableComponents/HeaderSection';
import ErrorModal from '../../components/reusableComponents/ErrorModal';

const useStyles = makeStyles((theme) => ({
	root: {
		'& .MuiChip-sizeSmall': {
			height: 36,
		},
	},
	accodin: {
		'& .MuiAccordionSummary-content': {
			justifyContent: 'space-between',
		},
	},
	searhform: {
		backgroundImage: `url(${Home})`,
		height: 272,
		backgroundSize: 'cover',
		backgroundRepeat: 'no-repeat',

		paddingTop: 124,
		[theme.breakpoints.down('md')]: {
			height: 508,
		},
		[theme.breakpoints.down('xs')]: {
			height: 590,
		},
	},
	radio: {
		'& .MuiTypography-body1': {
			fontSize: 13,
		},
	},
}));

const GreenCheckbox = withStyles({
	root: {
		color: 'rgb(239, 51, 57)',
		'&$checked': {
			color: 'rgb(239, 51, 57)',
		},
	},
	checked: {},
})((props) => <Checkbox color='default' {...props} />);
const OneWay = () => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const [expanded, setExpanded] = React.useState('');
	const [check, setCheck] = useState(false);
	const [check2, setCheck2] = useState(false);
	const [check3, setCheck3] = useState(false);
	const [check4, setCheck4] = useState(false);
	const [check5, setCheck5] = useState(false);
	const [rule, SetRule] = useState(false);
	const [scrollVal, SetScrollVal] = useState(10);
	const [scrollValResult, SetScrollValResult] = useState(10);
	const [hasMoreresult, SethasMoreResult] = useState(true);
	const [hasMorefilterData, SethasMoreFilterData] = useState(true);
	const [result, setResult] = useState(null);
	const history = useHistory();
	const theme = useTheme();
	const location = useLocation();
	const [toggle, setToggle] = useState(false);
	const { search, loading, onewayflightdata, onewayflightdataEtrav } =
		useSelector((state) => state.home);
	const { filterDataR } = useSelector((state) => state.ui);
	const [stop1, setStop1] = useState(false);
	const [value, setValue] = React.useState([1000, 5000]);

	const [stop2, setStop2] = useState(false);
	const [stop3, setStop3] = useState(false);
	const [morning, setMorning] = useState(false);
	const [dophar, setDOphar] = useState(false);
	const matches = useMediaQuery(theme.breakpoints.down('sm'));
	const matches2 = useMediaQuery(theme.breakpoints.down('xs'));
	const handleSlider = (event, newValue) => {
		setValue(newValue);
		console.log(newValue);
		let combineflightData = [];
		let checkDataTBO = [];
		let checkDataEtrav = [];
		if (onewayflightdata && newValue) {
			onewayflightdata &&
				onewayflightdata.result &&
				onewayflightdata.result.Response &&
				onewayflightdata.result.Response.Results[0].length > 0 &&
				onewayflightdata.result.Response.Results[0].map((item) => {
					let a = item.Fare.OfferedFare;
					let b = newValue[0];
					let c = newValue[1];
					if (a >= b && a <= c) {
						checkDataTBO.push({
							...item,
						});
					}
				});
		}
		if (onewayflightdataEtrav && newValue) {
			onewayflightdataEtrav &&
				onewayflightdataEtrav.result &&
				onewayflightdataEtrav.result.TripDetails[0] &&
				onewayflightdataEtrav.result.TripDetails[0].Flights.length > 0 &&
				onewayflightdataEtrav.result.TripDetails[0].Flights.map((item) => {
					let a = item.Fares[0].FareDetails[0].Total_Amount;
					let b = newValue[0];
					let c = newValue[1];
					if (a >= b && a <= c) {
						checkDataEtrav.push({
							...item,
						});
					}
				});
		}
		combineflightData = [...checkDataTBO, ...checkDataEtrav];
		console.log('checkData', combineflightData);
		setResult(combineflightData);
		SetScrollValResult(10);
		// console.log('Slider Value', checkData);
	};
	const handleCheck = (event) => {
		setCheck(event.target.checked);
		SetRule(event.target.checked);
		console.log(event.target.name);

		let combineflightData = [];
		let checkDataTBO = [];
		let checkDataEtrav = [];
		if (onewayflightdata && event.target.name) {
			onewayflightdata &&
				onewayflightdata.result &&
				onewayflightdata.result.Response &&
				onewayflightdata.result.Response.Results[0].length > 0 &&
				onewayflightdata.result.Response.Results[0].map((item) => {
					if (item.AirlineCode === event.target.name) {
						checkDataTBO.push({
							...item,
						});
					}
				});
		}
		console.log('checkDataTBO', checkDataTBO);
		if (onewayflightdataEtrav && event.target.name) {
			onewayflightdataEtrav &&
				onewayflightdataEtrav.result &&
				onewayflightdataEtrav.result.TripDetails[0].Flights.length > 0 &&
				onewayflightdataEtrav.result.TripDetails[0].Flights.map((item) => {
					if (item.Airline_Code === event.target.name) {
						checkDataEtrav.push({
							...item,
						});
					}
				});
		}
		console.log('checkDataEtrav', checkDataEtrav);
		combineflightData = [...checkDataTBO, ...checkDataEtrav];
		console.log('checkData', combineflightData);
		console.log(check);
		if (combineflightData.length > 0) {
			if (check) {
				setResult([]);
				SetScrollVal(10);
				SetScrollValResult(10);
			} else {
				setResult(...result, combineflightData);
			}
		}
	};
	const handleCheckGO = (event) => {
		setCheck2(event.target.checked);
		SetRule(event.target.checked);
		console.log(event.target.name);
		let combineflightData = [];
		let checkDataTBO = [];
		let checkDataEtrav = [];
		if (onewayflightdata && event.target.name) {
			onewayflightdata &&
				onewayflightdata.result &&
				onewayflightdata.result.Response &&
				onewayflightdata.result.Response.Results[0].length > 0 &&
				onewayflightdata.result.Response.Results[0].map((item) => {
					if (item.AirlineCode === event.target.name) {
						checkDataTBO.push({
							...item,
						});
					}
				});
		}
		console.log('checkDataTBO', checkDataTBO);
		if (onewayflightdataEtrav && event.target.name) {
			onewayflightdataEtrav &&
				onewayflightdataEtrav.result &&
				onewayflightdataEtrav.result.TripDetails[0].Flights.length > 0 &&
				onewayflightdataEtrav.result.TripDetails[0].Flights.map((item) => {
					if (item.Airline_Code === event.target.name) {
						checkDataEtrav.push({
							...item,
						});
					}
				});
		}
		console.log('checkDataEtrav', checkDataEtrav);
		combineflightData = [...checkDataTBO, ...checkDataEtrav];
		console.log('checkData', combineflightData);
		if (combineflightData.length > 0) {
			if (check2) {
				setResult([]);
				SetScrollVal(10);
				SetScrollValResult(10);
			} else {
				setResult(...result, combineflightData);
			}
		}
	};
	const handleCheckIndigo = (event) => {
		setCheck3(event.target.checked);
		SetRule(event.target.checked);
		console.log(event.target.name);
		let combineflightData = [];
		let checkDataTBO = [];
		let checkDataEtrav = [];
		if (onewayflightdata && event.target.name) {
			onewayflightdata &&
				onewayflightdata.result &&
				onewayflightdata.result.Response &&
				onewayflightdata.result.Response.Results[0].length > 0 &&
				onewayflightdata.result.Response.Results[0].map((item) => {
					if (item.AirlineCode === event.target.name) {
						checkDataTBO.push({
							...item,
						});
					}
				});
		}
		console.log('checkDataTBO', checkDataTBO);
		if (onewayflightdataEtrav && event.target.name) {
			onewayflightdataEtrav &&
				onewayflightdataEtrav.result &&
				onewayflightdataEtrav.result.TripDetails[0].Flights.length > 0 &&
				onewayflightdataEtrav.result.TripDetails[0].Flights.map((item) => {
					if (item.Airline_Code === event.target.name) {
						checkDataEtrav.push({
							...item,
						});
					}
				});
		}
		console.log('checkDataEtrav', checkDataEtrav);
		combineflightData = [...checkDataTBO, ...checkDataEtrav];
		console.log('checkData', combineflightData);
		if (combineflightData.length > 0) {
			if (check3) {
				setResult([]);
				SetScrollVal(10);
				SetScrollValResult(10);
			} else {
				setResult(...result, combineflightData);
			}
		}
	};
	const handleCheckAir = (event) => {
		setCheck4(event.target.checked);
		SetRule(event.target.checked);
		console.log(event.target.name);
		let combineflightData = [];
		let checkDataTBO = [];
		let checkDataEtrav = [];
		if (onewayflightdata && event.target.name) {
			onewayflightdata &&
				onewayflightdata.result &&
				onewayflightdata.result.Response &&
				onewayflightdata.result.Response.Results[0].length > 0 &&
				onewayflightdata.result.Response.Results[0].map((item) => {
					if (item.AirlineCode === event.target.name) {
						checkDataTBO.push({
							...item,
						});
					}
				});
		}
		console.log('checkDataTBO', checkDataTBO);
		if (onewayflightdataEtrav && event.target.name) {
			onewayflightdataEtrav &&
				onewayflightdataEtrav.result &&
				onewayflightdataEtrav.result.TripDetails[0].Flights.length > 0 &&
				onewayflightdataEtrav.result.TripDetails[0].Flights.map((item) => {
					if (item.Airline_Code === event.target.name) {
						checkDataEtrav.push({
							...item,
						});
					}
				});
		}
		console.log('checkDataEtrav', checkDataEtrav);
		combineflightData = [...checkDataTBO, ...checkDataEtrav];
		console.log('checkData', combineflightData);
		if (combineflightData.length > 0) {
			if (check4) {
				setResult([]);
				SetScrollVal(10);
				SetScrollValResult(10);
			} else {
				setResult(...result, combineflightData);
			}
		}
	};
	const handleCheckVistara = (event) => {
		setCheck5(event.target.checked);
		SetRule(event.target.checked);
		console.log(event.target.name);
		let combineflightData = [];
		let checkDataTBO = [];
		let checkDataEtrav = [];
		if (onewayflightdata && event.target.name) {
			onewayflightdata &&
				onewayflightdata.result &&
				onewayflightdata.result.Response &&
				onewayflightdata.result.Response.Results[0].length > 0 &&
				onewayflightdata.result.Response.Results[0].map((item) => {
					if (item.AirlineCode === event.target.name) {
						checkDataTBO.push({
							...item,
						});
					}
				});
		}
		console.log('checkDataTBO', checkDataTBO);
		if (onewayflightdataEtrav && event.target.name) {
			onewayflightdataEtrav &&
				onewayflightdataEtrav.result &&
				onewayflightdataEtrav.result.TripDetails[0].Flights.length > 0 &&
				onewayflightdataEtrav.result.TripDetails[0].Flights.map((item) => {
					if (item.Airline_Code === event.target.name) {
						checkDataEtrav.push({
							...item,
						});
					}
				});
		}
		console.log('checkDataEtrav', checkDataEtrav);
		combineflightData = [...checkDataTBO, ...checkDataEtrav];
		console.log('checkData', combineflightData);
		if (combineflightData.length > 0) {
			if (check5) {
				setResult([]);
				SetScrollVal(10);
				SetScrollValResult(10);
			} else {
				setResult(...result, combineflightData);
			}
		}
	};
	const handleChange = (panel) => (event, newExpanded) => {
		setExpanded(newExpanded ? panel : false);
	};

	function valuetext(value) {
		return `${value}°C`;
	}
	function hrToMin(a, b) {
		let hours = Math.trunc(a * 60);
		let minutes = b;
		return hours + minutes;
	}
	function convertH2M(timeInHour) {
		console.log(timeInHour);
		var timeParts = timeInHour.split(':');
		return Number(timeParts[0]) * 60 + Number(timeParts[1]);
	}
	function timeConvert(n) {
		var num = n;
		var hours = num / 60;
		var rhours = Math.floor(hours);
		var minutes = (hours - rhours) * 60;
		var rminutes = Math.round(minutes);
		return rhours + ' hr and ' + rminutes + ' min.';
	}
	console.log(location.state);

	let combineflightData = [];
	let filterData = [];
	if (loading) {
		console.log('Loading');
	} else {
		if (
			onewayflightdata &&
			onewayflightdata.status === 200 &&
			onewayflightdataEtrav &&
			onewayflightdataEtrav.status === 200
		) {
			let tbo =
				onewayflightdata &&
				onewayflightdata.result &&
				onewayflightdata.result.Response &&
				onewayflightdata.result.Response.Results[0].length > 0 &&
				onewayflightdata.result.Response.Results[0];
			let Etrav =
				onewayflightdataEtrav &&
				onewayflightdataEtrav.result &&
				onewayflightdataEtrav.result.TripDetails &&
				onewayflightdataEtrav.result.TripDetails[0].Flights.length > 0 &&
				onewayflightdataEtrav.result.TripDetails[0].Flights;

			combineflightData = [...tbo, ...Etrav];
			filterData =
				combineflightData &&
				combineflightData.length > 0 &&
				combineflightData.slice().sort((a, b) => {
					let first = a.Fare
						? a.Fare.OfferedFare
						: a.Fares[0].FareDetails
						? a.Fares[0].FareDetails[0].Total_Amount
						: a.Fare.OfferedFare;
					let second = b.Fare
						? b.Fare.OfferedFare
						: b.Fares[0].FareDetails
						? b.Fares[0].FareDetails[0].Total_Amount
						: b.Fare.OfferedFare;
					return first - second;
				});
		} else if (
			onewayflightdata &&
			onewayflightdata.status === 200 &&
			onewayflightdataEtrav &&
			onewayflightdataEtrav.status === 202
		) {
			filterData =
				onewayflightdata &&
				onewayflightdata.result &&
				onewayflightdata.result.Response &&
				onewayflightdata.result.Response.Results[0].length > 0 &&
				onewayflightdata.result.Response.Results[0].slice().sort((a, b) => {
					return a.Fare.OfferedFare - b.Fare.OfferedFare;
				});
		} else if (
			onewayflightdataEtrav &&
			onewayflightdataEtrav.status === 200 &&
			onewayflightdata &&
			onewayflightdata.status === 202
		) {
			filterData =
				onewayflightdataEtrav &&
				onewayflightdataEtrav.result &&
				onewayflightdataEtrav.result.TripDetails &&
				onewayflightdataEtrav.result.TripDetails[0].Flights.length > 0 &&
				onewayflightdataEtrav.result.TripDetails[0].Flights.slice().sort(
					(a, b) => {
						return (
							a.Fares[0].FareDetails[0].Total_Amount -
							b.Fares[0].FareDetails[0].Total_Amount
						);
					}
				);
		}
	}

	console.log('TBO', combineflightData);
	// let filterData = [];
	// filterData =
	// 	combineflightData &&
	// 	combineflightData.length > 0 &&
	// 	combineflightData.slice().sort((a, b) => {
	// 		let first = a.Fare
	// 			? a.Fare.OfferedFare
	// 			: a.Fares[0].FareDetails
	// 			? a.Fares[0].FareDetails[0].Total_Amount
	// 			: a.Fare.OfferedFare;
	// 		let second = b.Fare
	// 			? b.Fare.OfferedFare
	// 			: b.Fares[0].FareDetails
	// 			? b.Fares[0].FareDetails[0].Total_Amount
	// 			: b.Fare.OfferedFare;
	// 		return first - second;
	// 	});
	// console.log('fILTER', filterData);

	if (onewayflightdata) {
	}

	console.log('FilterData', filterData);

	const fetchMoreData = () => {
		if (scrollVal >= filterData.length) {
			SethasMoreFilterData(false);
		}

		setTimeout(() => {
			SetScrollVal(scrollVal + 5);
		}, 500);
	};
	const fetchMoreDataResult = () => {
		if (scrollValResult >= filterData.length) {
			SethasMoreResult(false);
		}
		setTimeout(() => {
			SetScrollValResult(scrollValResult + 5);
		}, 500);
	};

	useEffect(() => {
		if (location.state) {
			dispatch(SearchFormDispatch(location.state.body, history));
		}
	}, [dispatch]);

	const handleZero = () => {
		SetRule(true);
		let combineflightData = [];
		let checkDataTBO = [];
		let checkDataEtrav = [];
		if (onewayflightdata) {
			onewayflightdata &&
				onewayflightdata.result &&
				onewayflightdata.result.Response &&
				onewayflightdata.result.Response.Results[0].length > 0 &&
				onewayflightdata.result.Response.Results[0].map((item) => {
					if (item.Segments[0].length === 1) {
						checkDataTBO.push({
							...item,
						});
					}
				});
		}
		if (onewayflightdataEtrav) {
			onewayflightdataEtrav &&
				onewayflightdataEtrav.result &&
				onewayflightdataEtrav.result.TripDetails[0] &&
				onewayflightdataEtrav.result.TripDetails[0].Flights.length > 0 &&
				onewayflightdataEtrav.result.TripDetails[0].Flights.map((item) => {
					if (item.Segments.length === 1) {
						checkDataEtrav.push({
							...item,
						});
					}
				});
		}
		combineflightData = [...checkDataTBO, ...checkDataEtrav];
		console.log('TBO', checkDataTBO);
		console.log('Etrav', checkDataEtrav);
		console.log(combineflightData);
		if (stop1) {
			setResult([]);
			SetScrollVal(10);
			SetScrollValResult(10);
		} else {
			setResult(combineflightData);
		}
	};
	const handleOne = () => {
		SetRule(true);
		let combineflightData = [];
		let checkDataTBO = [];
		let checkDataEtrav = [];
		if (onewayflightdata) {
			onewayflightdata &&
				onewayflightdata.result &&
				onewayflightdata.result.Response &&
				onewayflightdata.result.Response.Results[0].length > 0 &&
				onewayflightdata.result.Response.Results[0].map((item) => {
					if (item.Segments[0].length === 2) {
						checkDataTBO.push({
							...item,
						});
					}
				});
		}
		if (onewayflightdataEtrav) {
			onewayflightdataEtrav &&
				onewayflightdataEtrav.result &&
				onewayflightdataEtrav.result.TripDetails[0] &&
				onewayflightdataEtrav.result.TripDetails[0].Flights.length > 0 &&
				onewayflightdataEtrav.result.TripDetails[0].Flights.map((item) => {
					if (item.Segments.length === 2) {
						checkDataEtrav.push({
							...item,
						});
					}
				});
		}
		combineflightData = [...checkDataTBO, ...checkDataEtrav];
		console.log('TBO', checkDataTBO);
		console.log('Etrav', checkDataEtrav);
		console.log(combineflightData);
		if (stop2) {
			setResult([]);
			SetScrollVal(10);
			SetScrollValResult(10);
		} else {
			setResult(combineflightData);
		}
	};
	const handleTwo = () => {
		SetRule(true);
		let combineflightData = [];
		let checkDataTBO = [];
		let checkDataEtrav = [];
		if (onewayflightdata) {
			onewayflightdata &&
				onewayflightdata.result &&
				onewayflightdata.result.Response &&
				onewayflightdata.result.Response.Results[0].length > 0 &&
				onewayflightdata.result.Response.Results[0].map((item) => {
					if (item.Segments[0].length === 3) {
						checkDataTBO.push({
							...item,
						});
					}
				});
		}
		if (onewayflightdataEtrav) {
			onewayflightdataEtrav &&
				onewayflightdataEtrav.result &&
				onewayflightdataEtrav.result.TripDetails[0] &&
				onewayflightdataEtrav.result.TripDetails[0].Flights.length > 0 &&
				onewayflightdataEtrav.result.TripDetails[0].Flights.map((item) => {
					if (item.Segments.length === 3) {
						checkDataEtrav.push({
							...item,
						});
					}
				});
		}
		combineflightData = [...checkDataTBO, ...checkDataEtrav];
		console.log('TBO', checkDataTBO);
		console.log('Etrav', checkDataEtrav);
		console.log(combineflightData);
		if (stop3) {
			setResult([]);
			SetScrollVal(10);
			SetScrollValResult(10);
		} else {
			setResult(combineflightData);
		}
	};
	const handlemorning = () => {
		SetRule(true);
		let checkData = [];
		if (onewayflightdata) {
			onewayflightdata &&
				onewayflightdata.result &&
				onewayflightdata.result.Response &&
				onewayflightdata.result.Response.Results[0].length > 0 &&
				onewayflightdata.result.Response.Results[0].map((item) => {
					console.log(
						item.Segments[0].slice(0, 1).map((i) => {
							return i.Origin.DepTime.substr(11, 2);
						})
					);
					console.log(
						'Dept',
						item.Segments[0].slice(0, 1).map((i) => {
							return i.Destination.ArrTime.substr(11, 2);
						})
					);
					let a = item.Segments[0].slice(0, 1).map((i) => {
						return i.Origin.DepTime.substr(11, 2);
					});
					let b = item.Segments[0].slice(0, 1).map((i) => {
						return i.Destination.ArrTime.substr(11, 2);
					});
					if (a >= 5 && b <= 12) {
						checkData.push({
							...item,
						});
					}
				});
		}
		if (morning) {
			setResult([]);
			SetScrollVal(10);
			SetScrollValResult(10);
		} else {
			setResult(checkData);
		}
		console.log('Morning', checkData);
	};
	const handledophar = () => {
		SetRule(true);
		let checkData = [];
		if (onewayflightdata) {
			onewayflightdata &&
				onewayflightdata.result &&
				onewayflightdata.result.Response &&
				onewayflightdata.result.Response.Results[0].length > 0 &&
				onewayflightdata.result.Response.Results[0].map((item) => {
					console.log(
						item.Segments[0].slice(0, 1).map((i) => {
							return i.Origin.DepTime.substr(11, 2);
						})
					);
					console.log(
						'Dept',
						item.Segments[0].slice(0, 1).map((i) => {
							return i.Destination.ArrTime.substr(11, 2);
						})
					);
					let a = item.Segments[0].slice(0, 1).map((i) => {
						return i.Origin.DepTime.substr(11, 2);
					});
					let b = item.Segments[0].slice(0, 1).map((i) => {
						return i.Destination.ArrTime.substr(11, 2);
					});
					if (a >= 12 && b <= 18) {
						checkData.push({
							...item,
						});
					}
				});
		}
		if (dophar) {
			setResult([]);
			SetScrollVal(10);
			SetScrollValResult(10);
		} else {
			setResult(checkData);
		}
		console.log('Dophar', checkData);
	};

	return (
		<>
			{/* Header Starting */}
			<HeaderSection id={1} />
			{/* Header Ending */}

			{/* Oneway Form Starting */}
			{toggle ? (
				<Box
					styel={{ transition: 'all 0.5s ease' }}
					className={classes.searhform}>
					<Container>
						<OnewayForm />
					</Container>
				</Box>
			) : (
				''
			)}

			{/* Oneway Form Ending */}
			<Box style={{ background: 'white', marginTop: 80 }}>
				<Container>
					<Box
						display='flex'
						justifyContent='space-between'
						style={{
							textAlign: 'justify',
							border: '1px solid #d7d7d7',
							padding: 10,
							background: 'white',
						}}>
						<BodyText
							textStyle={{
								color: 'red',
								fontFamily: 'Josefin Sans, sans-serif',
								fontWeight: 500,
								fontSize: 16,
							}}>
							Important Information
						</BodyText>
						<Box
							style={{ cursor: 'pointer' }}
							onClick={() => (toggle ? setToggle(false) : setToggle(true))}>
							<TitleText>Modify Search</TitleText>
						</Box>
					</Box>
					{loading ? (
						// <Skeleton variant='rectangular' width='100%' height={118} />
						<marquee direction='right'>
							<img
								src={flightrun}
								style={{ width: 100, height: 32, marginTop: 10 }}
							/>
						</marquee>
					) : (
						<Box className={classes.accodin}>
							<Accordion
								square
								expanded={expanded === 'panel1'}
								onChange={handleChange('panel1')}>
								<AccordionSummary
									aria-controls='panel1d-content'
									id='panel1d-header'>
									<Box alignItems='center'>
										<i class='fa-solid fa-filter'></i>
									</Box>
									<Hidden only={['xs']}>
										<Box display='flex' alignItems='center'>
											<TitleText
												textStyle={{
													fontFamily: 'Josefin Sans, sans-serif',
													fontWeight: 500,
													fontSize: 14,
												}}>
												STOPS
											</TitleText>
											<ExpandMoreIcon />
										</Box>
										<Box display='flex' alignItems='center'>
											<TitleText
												textStyle={{
													fontFamily: 'Josefin Sans, sans-serif',
													fontWeight: 500,
													fontSize: 14,
												}}>
												PRICE
											</TitleText>
											<ExpandMoreIcon />
										</Box>
										<Box display='flex' alignItems='center'>
											<TitleText
												textStyle={{
													fontFamily: 'Josefin Sans, sans-serif',
													fontWeight: 500,
													fontSize: 14,
												}}>
												AIRLINE
											</TitleText>
											<ExpandMoreIcon />
										</Box>
										<Box display='flex' alignItems='center'>
											<TitleText
												textStyle={{
													fontFamily: 'Josefin Sans, sans-serif',
													fontWeight: 500,
													fontSize: 14,
												}}>
												DEPARTURE TIME
											</TitleText>
											<ExpandMoreIcon />
										</Box>
									</Hidden>
									<Box display='flex' alignItems='center'>
										<TitleText
											textStyle={{
												fontFamily: 'Josefin Sans, sans-serif',
												fontWeight: 500,
												fontSize: 14,
											}}>
											RESET ALL
										</TitleText>
									</Box>
								</AccordionSummary>
								<AccordionDetails>
									<Grid container>
										<Grid item xs={12} lg={3}>
											<Box
												display={'flex'}
												style={{ padding: 10, marginLeft: 50 }}>
												<Box
													onClick={() => {
														handleZero();
														stop1 ? setStop1(false) : setStop1(true);
														rule ? SetRule(false) : SetRule(true);
													}}
													style={{
														width: '40px',
														padding: '6px 0px',
														background: stop1 ? 'rgb(239, 51, 57)' : '#eee',
														color: stop1 ? 'white' : '#666',
														border: '1px solid #ddd',
														borderRadius: '2px',
														fontWeight: 700,
														textAlign: 'center',
														cursor: 'pointer',
													}}>
													<BodyText textStyle={{ fontSize: 14 }}>0</BodyText>
												</Box>
												<Box
													onClick={() => {
														handleOne();
														stop2 ? setStop2(false) : setStop2(true);
														rule ? SetRule(false) : SetRule(true);
													}}
													style={{
														width: '40px',
														padding: '6px 0px',
														background: stop2 ? 'rgb(239, 51, 57)' : '#eee',
														color: stop2 ? 'white' : '#666',
														border: '1px solid #ddd',
														borderRadius: '2px',
														fontWeight: 700,
														textAlign: 'center',
														marginLeft: 10,
														cursor: 'pointer',
													}}>
													<BodyText textStyle={{ fontSize: 14 }}>1</BodyText>
												</Box>
												<Box
													onClick={() => {
														handleTwo();
														stop3 ? setStop3(false) : setStop3(true);
														rule ? SetRule(false) : SetRule(true);
													}}
													style={{
														width: '40px',
														padding: '6px 0px',
														background: stop3 ? 'rgb(239, 51, 57)' : '#eee',
														color: stop3 ? 'white' : '#666',
														border: '1px solid #ddd',
														borderRadius: '2px',
														fontWeight: 700,
														textAlign: 'center',
														marginLeft: 10,
														cursor: 'pointer',
													}}>
													<BodyText textStyle={{ fontSize: 14 }}>2</BodyText>
												</Box>
											</Box>
										</Grid>
										<Grid item xs={12} lg={3}>
											<Box>
												<Slider
													style={{ maxWidth: 500, color: 'rgb(239, 51, 57)' }}
													value={value}
													min={1000}
													max={10000}
													aria-label='Default'
													onChange={handleSlider}
													valueLabelDisplay='auto'
													aria-labelledby='non-linear-slider'
												/>
												<Box display='flex' justifyContent='space-between'>
													<BodyText>Min: {value[0]}</BodyText>
													<BodyText>Max: {value[1]}</BodyText>
												</Box>
											</Box>
										</Grid>
										<Grid item xs={12} lg={3}>
											<Box
												ml={'20px'}
												mt={matches ? '20px' : ''}
												className={classes.radio}>
												<FormControlLabel
													control={
														<GreenCheckbox
															checked={check}
															onChange={handleCheck}
															name='SG'
														/>
													}
													label='SpiceJet'
												/>
												<br />
												<FormControlLabel
													control={
														<GreenCheckbox
															checked={check2}
															onChange={handleCheckGO}
															name='G8'
														/>
													}
													label='GO FIRST'
												/>
												<br />
												<FormControlLabel
													control={
														<GreenCheckbox
															checked={check3}
															onChange={handleCheckIndigo}
															name='6E'
														/>
													}
													label='Indigo'
												/>
												<br />
												<FormControlLabel
													control={
														<GreenCheckbox
															checked={check4}
															onChange={handleCheckAir}
															name='I5'
														/>
													}
													label='Air Asia'
												/>
												<br />
												<FormControlLabel
													control={
														<GreenCheckbox
															checked={check5}
															onChange={handleCheckVistara}
															name='UK'
														/>
													}
													label='Vistara'
												/>
												<br />
											</Box>
										</Grid>
										<Grid item xs={12} lg={3}>
											<Box display='flex' mt={matches ? '20px' : ''}>
												<Box
													onClick={() => {
														handlemorning();
														morning ? setMorning(false) : setMorning(true);
														rule ? SetRule(false) : SetRule(true);
													}}
													style={{
														display: 'block',
														padding: '6px 10px',
														textAlign: 'center',
														background: morning
															? 'rgb(239, 51, 57)'
															: '#8f8f8f',
														color: morning ? 'white' : '',
														borderRight: '1px solid #ddd',
														fontWeight: 700,
														cursor: 'pointer',
													}}>
													<WbSunnyIcon />
													<Box>
														<BodyText one textStyle={{ color: 'white' }}>
															05-12
														</BodyText>
													</Box>
												</Box>
												<Box
													onClick={() => {
														handledophar();
														dophar ? setDOphar(false) : setDOphar(true);
														rule ? SetRule(false) : SetRule(true);
													}}
													ml={'10px'}
													style={{
														display: 'block',
														padding: '6px 10px',
														textAlign: 'center',
														borderRight: '1px solid #ddd',
														fontWeight: 700,
														cursor: 'pointer',
														background: dophar ? 'rgb(239, 51, 57)' : '#8f8f8f',
														color: dophar ? 'white' : '',
													}}>
													<WbSunnyIcon />
													<Box>
														<BodyText one textStyle={{ color: 'white' }}>
															12-18
														</BodyText>
													</Box>
												</Box>
											</Box>
										</Grid>
									</Grid>
								</AccordionDetails>
							</Accordion>
						</Box>
					)}

					<Grid container style={{ marginTop: 20 }} spacing={2}>
						<Grid item xs={12}>
							<Grid container spacing={4}>
								<Hidden only={['xs', 'sm']}>
									<Grid item xs={3} lg={3}>
										{/* <Box>
											<img src={flightpro} width='100%' height='216px'></img>
										</Box> */}
										<Box mt={'10px'}>
											<img src={h1} width='100%' height='216px'></img>
										</Box>
										<Box mt={'10px'}>
											<img src={h2} width='100%' height='216px'></img>
										</Box>
										<Box mt={'10px'}>
											<img src={h3} width='100%' height='216px'></img>
										</Box>
										<Box mt={'10px'}>
											<img src={h4} width='100%' height='216px'></img>
										</Box>
										<Box mt={'10px'}>
											<img src={h5} width='100%' height='216px'></img>
										</Box>
									</Grid>
								</Hidden>
								<Grid item xs={12} md={9} lg={9}>
									<Box
										display='flex'
										justifyContent='space-between'
										style={{
											background: '#eee',
											padding: '10px',
											borderBottom: '1px solid #ddd',
											margin: '0 0 15px',
										}}>
										<Box>
											<TitleText two textStyle={{ color: '#666' }}>
												SORT BY
											</TitleText>
										</Box>
										<Box>
											<TitleText two textStyle={{ color: '#666' }}>
												DEPART
											</TitleText>
										</Box>
										<Box>
											<TitleText two textStyle={{ color: '#666' }}>
												DURATION
											</TitleText>
										</Box>

										<Box>
											<TitleText two textStyle={{ color: '#666' }}>
												ARRIVAL
											</TitleText>
										</Box>
										<Box>
											<TitleText two textStyle={{ color: '#666' }}>
												PRICE(Per Adult)
											</TitleText>
										</Box>
									</Box>
									{loading ? (
										[0, 1, 2].map((i) => {
											return (
												<>
													<Box
														display='flex'
														style={{
															boxShadow: '3px 3px 16px -4px rgb(0 0 0 / 30%)',
															padding: 8,
														}}
														justifyContent='space-between'
														mt={'20px'}>
														<Box display='flex' alignItems='center'>
															<Skeleton
																variant='circle'
																width={40}
																height={40}
															/>

															<Box alignItems='center' ml={'5px'}>
																<TitleText two>
																	<Skeleton variant='text' width='60px' />
																</TitleText>

																<Skeleton variant='text' width='60px' />
															</Box>
														</Box>

														<Box>
															<Skeleton variant='text' width='60px' />

															<Skeleton variant='text' width='60px' />
														</Box>
														<Hidden only={['xs']}>
															<Box alignItems='center' textAlign='center'>
																<Skeleton variant='text' width='100px' />

																<Skeleton variant='text' width='60px' />
															</Box>
															<Box>
																<Skeleton variant='text' width='60px' />

																<Skeleton variant='text' width='60px' />
															</Box>
														</Hidden>
														<Box alignItems='center' display='flex'>
															<Skeleton
																variant='text'
																width='60px'
																height='30px'
															/>
															<Box style={{ marginLeft: 10 }}></Box>
															<Skeleton
																variant='text'
																width='60px'
																height='60px'
															/>
															<Skeleton
																variant='text'
																width='60px'
																height='60px'
															/>
														</Box>
													</Box>
													<Box
														style={{
															padding: '6px 10px',
															background: '#f5f6f6',
															borderBottomLeftRadius: 4,
															borderBottomRightRadius: 4,
															borderTop: '1px solid #e2e2e2',
														}}
														justifyContent='space-between'
														alignItems='center'
														display='flex'>
														<Box display='flex' alignItems='center'>
															<Skeleton
																variant='text'
																width='60px'
																height='40px'
															/>
														</Box>
														<Box
															onClick={() => {
																dispatch(toggleFlightModal(true));
															}}
															display='flex'
															style={{ width: '40%' }}
															justifyContent='space-between'>
															<Box>
																<Skeleton
																	variant='text'
																	width='60px'
																	height='40px'
																/>
															</Box>
															<Box display='flex'>
																<Skeleton
																	variant='text'
																	width='65px'
																	height='40px'
																/>
															</Box>
														</Box>
													</Box>
												</>
											);
										})
									) : rule || (result && result.length > 0) ? (
										result && result.length > 0 ? (
											<InfiniteScroll
												dataLength={scrollValResult}
												next={fetchMoreDataResult}
												hasMore={hasMoreresult}
												loader={<h4>Loading...</h4>}
												endMessage={
													<p style={{ textAlign: 'center' }}>
														<b>No More Data</b>
													</p>
												}>
												{result.map((item, index) => {
													return index < scrollValResult ? (
														matches ? (
															<>
																<Box
																	display='flex'
																	style={{
																		// boxShadow: '3px 3px 16px -4px rgb(0 0 0 / 30%)',
																		padding: 8,
																	}}
																	justifyContent='space-between'
																	alignItems='center'
																	mt={'20px'}>
																	<Box display='flex' alignItems='center'>
																		{loading ? (
																			<Skeleton
																				variant='circle'
																				width={40}
																				height={40}
																			/>
																		) : (
																			<img
																				src={`https://nitish.musafirbazar.com/static/media/${item.Segments[0]
																					.slice(0, 1)
																					.map((i) => {
																						return i.Airline.AirlineCode;
																					})}.gif`}
																				width='50px'
																				height='25px'></img>
																		)}

																		<Box alignItems='center' ml={'5px'}>
																			<TitleText
																				three
																				textStyle={{
																					fontFamily:
																						'Josefin Sans, sans-serif',
																					fontWeight: 500,
																					color: '#3c3c3c',
																				}}>
																				{loading ? (
																					<Skeleton
																						variant='text'
																						width='60px'
																					/>
																				) : (
																					item.Segments[0]
																						.slice(0, 1)
																						.map((i) => {
																							return i.Airline.AirlineName;
																						})
																				)}
																			</TitleText>
																			{loading ? (
																				<Skeleton variant='text' width='60px' />
																			) : (
																				<BodyText
																					two
																					textStyle={{
																						fontFamily:
																							'Roboto Serif, sans-serif',
																						color: '#8f8f8f',
																						fontWeight: 600,
																					}}>
																					{item.Segments[0]
																						.slice(0, 1)
																						.map((i) => {
																							return i.Airline.AirlineCode;
																						})}
																					-
																					{item.Segments[0]
																						.slice(0, 1)
																						.map((i) => {
																							return i.Airline.FlightNumber;
																						})}
																				</BodyText>
																			)}
																		</Box>
																	</Box>

																	<Box alignItems='center' display='flex'>
																		{loading ? (
																			<Skeleton variant='text' width='60px' />
																		) : (
																			<TitleText
																				four
																				textStyle={{
																					fontFamily:
																						'Josefin Sans, sans-serif',
																					fontWeight: 500,
																				}}>
																				Rs {item.Fare.OfferedFare}
																			</TitleText>
																		)}

																		{/* <MoreVertIcon /> */}
																		{loading ? (
																			<Skeleton
																				variant='text'
																				width='60px'
																				height='60px'
																			/>
																		) : (
																			<Box
																				onClick={() => {
																					history.push({
																						pathname: '/flightsummary',
																						state: {
																							OneflightData: item,
																							body: location.state.body,
																							// ID:
																							// 	search &&
																							// 	search.data &&
																							// 	search.data.Response &&
																							// 	search.data.Response.TraceId,
																						},
																					});
																				}}
																				style={{
																					color: 'white',
																					background: 'rgb(239, 51, 57)',
																					padding: '8px 25px',
																					marginLEft: 5,
																					borderRadius: 8,
																					cursor: 'pointer',
																					fontFamily:
																						'Josefin Sans, sans-serif',
																					fontWeight: 500,
																					boxShadow:
																						'3px 3px 12px -6px rgb(0 0 0 / 70%)',
																				}}>
																				<TitleText textStyle={{ fontSize: 16 }}>
																					Book Now
																				</TitleText>
																			</Box>
																		)}
																	</Box>
																</Box>
																<Box
																	display='flex'
																	style={{
																		boxShadow:
																			'3px 3px 16px -4px rgb(0 0 0 / 30%)',
																		padding: 8,
																	}}
																	justifyContent='space-between'
																	alignItems='center'>
																	<Box>
																		{loading ? (
																			<Skeleton variant='text' width='60px' />
																		) : (
																			<TitleText
																				three
																				textStyle={{
																					fontFamily:
																						'Josefin Sans, sans-serif',
																					fontWeight: 500,
																				}}>
																				{item.FareRules[0].Origin}
																			</TitleText>
																		)}
																		{loading ? (
																			<Skeleton variant='text' width='60px' />
																		) : (
																			<TitleText three>
																				{item.Segments[0]
																					.slice(0, 1)
																					.map((i) => {
																						return i.Origin.DepTime.substr(
																							11,
																							5
																						);
																					})}
																			</TitleText>
																		)}
																	</Box>
																	<Box alignItems='center' textAlign='center'>
																		{loading ? (
																			<Skeleton variant='text' width='100px' />
																		) : (
																			<BodyText
																				three
																				textStyle={{
																					color: 'rgb(239, 51, 57)',
																					fontWeight: 700,
																					fontSize: 13,
																				}}>
																				{timeConvert(
																					item.Segments[0].length == 2
																						? Number(
																								item.Segments[0]
																									.filter(
																										(i, index) => index === 0
																									)
																									.map((it) => {
																										return it.Duration;
																									})
																						  ) +
																								Number(
																									item.Segments[0]
																										.filter(
																											(i, index) => index === 1
																										)
																										.map((it) => {
																											return it.Duration;
																										})
																								)
																						: item.Segments[0].length == 1
																						? item.Segments[0].map(
																								(i) => i.Duration
																						  )
																						: item.Segments[0].length == 3
																						? Number(
																								item.Segments[0]
																									.filter(
																										(i, index) => index === 0
																									)
																									.map((it) => {
																										return it.Duration;
																									})
																						  ) +
																						  Number(
																								item.Segments[0]
																									.filter(
																										(i, index) => index === 1
																									)
																									.map((it) => {
																										return it.Duration;
																									})
																						  ) +
																						  Number(
																								item.Segments[0]
																									.filter(
																										(i, index) => index === 2
																									)
																									.map((it) => {
																										return it.Duration;
																									})
																						  )
																						: ''
																				)}
																			</BodyText>
																		)}
																		{loading ? (
																			<Skeleton variant='text' width='60px' />
																		) : (
																			<BodyText
																				two
																				textStyle={{ color: '#8f8f8f' }}>
																				Non Stop
																			</BodyText>
																		)}
																	</Box>
																	<Box>
																		{loading ? (
																			<Skeleton variant='text' width='60px' />
																		) : (
																			<TitleText
																				three
																				textStyle={{
																					fontFamily:
																						'Josefin Sans, sans-serif',
																					fontWeight: 500,
																				}}>
																				{item.FareRules[0].Destination}
																			</TitleText>
																		)}
																		{loading ? (
																			<Skeleton variant='text' width='60px' />
																		) : (
																			<TitleText three>
																				{item.Segments[0]
																					.slice(0, 1)
																					.map((i) => {
																						return i.Destination.ArrTime.substr(
																							11,
																							5
																						);
																					})}
																			</TitleText>
																		)}
																	</Box>
																</Box>
																<Box
																	style={{
																		padding: '6px 10px',
																		background: '#f5f6f6',
																		borderBottomLeftRadius: 4,
																		borderBottomRightRadius: 4,
																		borderTop: '1px solid #e2e2e2',
																	}}
																	justifyContent='space-between'
																	alignItems='center'
																	display='flex'>
																	<Box display='flex' alignItems='center'>
																		{loading ? (
																			<Skeleton
																				variant='text'
																				width='60px'
																				height='40px'
																			/>
																		) : (
																			<Box
																				style={{
																					padding: '2px 10px',
																					background: '#f56d6d',
																					borderRadius: 4,
																					boxShadow:
																						'3px 3px 12px -6px rgb(0 0 0 / 70%)',
																				}}>
																				<BodyText
																					textStyle={{ color: 'white' }}>
																					{item.ResultFareType}
																				</BodyText>
																			</Box>
																		)}
																	</Box>
																	<Box
																		onClick={() => {
																			dispatch(toggleFlightModal(true));
																			dispatch(setFlightId(item.ResultIndex));
																			dispatch(
																				FlightFareRuleDispatch(
																					item.ResultIndex,
																					onewayflightdata &&
																						onewayflightdata.result &&
																						onewayflightdata.result.Response
																							.TraceId
																				)
																			);
																		}}
																		display='flex'
																		style={{ width: '40%' }}
																		justifyContent='space-between'>
																		<Box>
																			<BodyText
																				two
																				textStyle={{
																					fontFamily:
																						'Roboto Serif, sans-serif',
																				}}>
																				Free Meals
																			</BodyText>
																		</Box>
																		<Box display='flex' alignItems={'center'}>
																			<BodyText
																				two
																				textStyle={{
																					fontFamily:
																						'Roboto Serif, sans-serif',
																				}}>
																				Flight Details
																			</BodyText>
																			<ArrowDropDownIcon />
																		</Box>
																	</Box>
																</Box>
															</>
														) : (
															<>
																<Box
																	display='flex'
																	style={{
																		boxShadow:
																			'3px 3px 16px -4px rgb(0 0 0 / 30%)',
																		padding: 8,
																	}}
																	justifyContent='space-between'
																	alignItems='center'
																	mt={'20px'}>
																	<Box display='flex' alignItems='center'>
																		{loading ? (
																			<Skeleton
																				variant='circle'
																				width={40}
																				height={40}
																			/>
																		) : (
																			<img
																				src={`https://nitish.musafirbazar.com/static/media/${
																					item.AirlineCode
																						? item.AirlineCode
																						: item.Airline_Code
																						? item.Airline_Code
																						: item.AirlineCode
																				}.gif`}
																				width='50px'
																				height='25px'></img>
																		)}

																		<Box alignItems='center' ml={'5px'}>
																			<TitleText
																				three
																				textStyle={{
																					fontFamily:
																						'Josefin Sans, sans-serif',
																					fontWeight: 500,
																					color: '#3c3c3c',
																				}}>
																				{loading ? (
																					<Skeleton
																						variant='text'
																						width='60px'
																					/>
																				) : item.Airline_Code ? (
																					item.Segments[0].Airline_Name
																				) : (
																					item.Segments[0]
																						.slice(0, 1)
																						.map((i) => {
																							return i.Airline.AirlineName;
																						})
																				)}
																			</TitleText>
																			{loading ? (
																				<Skeleton variant='text' width='60px' />
																			) : (
																				<BodyText
																					two
																					textStyle={{
																						fontFamily:
																							'Roboto Serif, sans-serif',
																						color: '#8f8f8f',
																						fontWeight: 600,
																					}}>
																					{item.Airline_Code
																						? item.Segments[0].Airline_Code
																						: item.Segments[0]
																								.slice(0, 1)
																								.map((i) => {
																									return i.Airline.AirlineCode;
																								})}
																					-
																					{item.Airline_Code
																						? item.Segments[0].Flight_Number
																						: item.Segments[0]
																								.slice(0, 1)
																								.map((i) => {
																									return i.Airline.FlightNumber;
																								})}
																				</BodyText>
																			)}
																		</Box>
																	</Box>
																	<Box>
																		{loading ? (
																			<Skeleton variant='text' width='60px' />
																		) : (
																			<TitleText
																				three
																				textStyle={{
																					fontFamily:
																						'Josefin Sans, sans-serif',
																					fontWeight: 500,
																				}}>
																				{item.Origin
																					? item.Origin
																					: item.FareRules[0].Origin}
																			</TitleText>
																		)}
																		{loading ? (
																			<Skeleton variant='text' width='60px' />
																		) : (
																			<TitleText three>
																				{item.Airline_Code
																					? item.Segments[0].Departure_DateTime.substr(
																							11,
																							5
																					  )
																					: item.Segments[0]
																							.slice(0, 1)
																							.map((i) => {
																								return i.Origin.DepTime.substr(
																									11,
																									5
																								);
																							})}
																				{/* {console.log(
																				item.Segments[0]
																					.slice(0, 1)
																					.map((i) => {
																						return i.Origin.DepTime.substr(
																							11,
																							2
																						);
																					}) > 2
																					? 'YES'
																					: 'NO'
																			)} */}
																			</TitleText>
																		)}
																	</Box>
																	<Box alignItems='center' textAlign='center'>
																		{loading ? (
																			<Skeleton variant='text' width='100px' />
																		) : (
																			<BodyText
																				three
																				textStyle={{
																					color: 'rgb(239, 51, 57)',
																					fontWeight: 700,
																					fontSize: 13,
																				}}>
																				{console.log(
																					'Duration',
																					// convertH2M(
																					item.Segments.length === 2
																						? item.Airline_Code
																							? item.Segments.filter(
																									(i, index) => index === 0
																							  ).map((it) => {
																									return it.Duration;
																							  })
																							: ''
																						: ''
																					// )
																				)}
																				{timeConvert(
																					item.Airline_Code
																						? item.Segments.length === 2
																							? Number(
																									convertH2M(
																										item.Segments.filter(
																											(i, index) => index === 0
																										).map(
																											(it) => it.Duration
																										)[0]
																									)
																							  ) +
																							  Number(
																									convertH2M(
																										item.Segments.filter(
																											(i, index) => index === 1
																										).map(
																											(it) => it.Duration
																										)[0]
																									)
																							  )
																							: item.Segments.length === 1
																							? Number(
																									convertH2M(
																										item.Segments.filter(
																											(i, index) => index === 0
																										).map(
																											(it) => it.Duration
																										)[0]
																									)
																							  )
																							: ''
																						: item.Segments[0].length == 2
																						? Number(
																								item.Segments[0]
																									.filter(
																										(i, index) => index === 0
																									)
																									.map((it) => {
																										return it.Duration;
																									})
																						  ) +
																						  Number(
																								item.Segments[0]
																									.filter(
																										(i, index) => index === 1
																									)
																									.map((it) => {
																										return it.Duration;
																									})
																						  )
																						: item.Segments[0].length == 1
																						? item.Segments[0].map(
																								(i) => i.Duration
																						  )
																						: item.Segments[0].length == 3
																						? Number(
																								item.Segments[0]
																									.filter(
																										(i, index) => index === 0
																									)
																									.map((it) => {
																										return it.Duration;
																									})
																						  ) +
																						  Number(
																								item.Segments[0]
																									.filter(
																										(i, index) => index === 1
																									)
																									.map((it) => {
																										return it.Duration;
																									})
																						  ) +
																						  Number(
																								item.Segments[0]
																									.filter(
																										(i, index) => index === 2
																									)
																									.map((it) => {
																										return it.Duration;
																									})
																						  )
																						: ''
																				)}
																			</BodyText>
																		)}
																		{loading ? (
																			<Skeleton variant='text' width='60px' />
																		) : (
																			<BodyText
																				two
																				textStyle={{ color: '#8f8f8f' }}>
																				Non Stop
																			</BodyText>
																		)}
																	</Box>
																	<Box>
																		{loading ? (
																			<Skeleton variant='text' width='60px' />
																		) : (
																			<TitleText
																				three
																				textStyle={{
																					fontFamily:
																						'Josefin Sans, sans-serif',
																					fontWeight: 500,
																				}}>
																				{item.Airline_Code
																					? item.Segments.length === 1
																						? item.Segments.filter(
																								(i, index) => index === 0
																						  ).map((it) => {
																								return it.Destination;
																						  })
																						: item.Segments.length === 2
																						? item.Segments.filter(
																								(i, index) => index === 1
																						  ).map((it) => {
																								return it.Destination;
																						  })
																						: item.Segments.length === 3
																						? item.Segments.filter(
																								(i, index) => index === 2
																						  ).map((it) => {
																								return it.Destination;
																						  })
																						: ''
																					: item.Segments[0].length == 2
																					? item.Segments[0]
																							.filter((i, index) => index === 1)
																							.map((it) => {
																								return it.Destination.Airport
																									.AirportCode;
																							})
																					: item.Segments[0].length == 3
																					? item.Segments[0]
																							.filter((i, index) => index === 2)
																							.map((it) => {
																								return it.Destination.Airport
																									.AirportCode;
																							})
																					: item.Segments[0].length == 1
																					? item.Segments[0].map((it) => {
																							return it.Destination.Airport
																								.AirportCode;
																					  })
																					: ''}
																			</TitleText>
																		)}
																		{loading ? (
																			<Skeleton variant='text' width='60px' />
																		) : (
																			<TitleText three>
																				{item.Airline_Code
																					? item.Segments.length === 1
																						? item.Segments.filter(
																								(i, index) => index === 0
																						  ).map((it) => {
																								return it.Departure_DateTime.substr(
																									11,
																									5
																								);
																						  })
																						: item.Segments.length === 2
																						? item.Segments.filter(
																								(i, index) => index === 1
																						  ).map((it) => {
																								return it.Departure_DateTime.substr(
																									11,
																									5
																								);
																						  })
																						: item.Segments.length === 3
																						? item.Segments.filter(
																								(i, index) => index === 2
																						  ).map((it) => {
																								return it.Departure_DateTime.substr(
																									11,
																									5
																								);
																						  })
																						: ''
																					: item.Segments[0].length == 3
																					? item.Segments[0]
																							.filter((i, index) => index === 2)
																							.map((i) => {
																								return i.Destination.ArrTime.substr(
																									11,
																									5
																								);
																							})
																					: item.Segments[0].length == 2
																					? item.Segments[0]
																							.filter((i, index) => index === 1)
																							.map((i) => {
																								return i.Destination.ArrTime.substr(
																									11,
																									5
																								);
																							})
																					: item.Segments[0].length == 1
																					? item.Segments[0]
																							.filter((i, index) => index === 0)
																							.map((i) => {
																								return i.Destination.ArrTime.substr(
																									11,
																									5
																								);
																							})
																					: ''}
																			</TitleText>
																		)}
																	</Box>
																	<Box alignItems='center' display='flex'>
																		{loading ? (
																			<Skeleton variant='text' width='60px' />
																		) : (
																			<TitleText
																				textStyle={{
																					fontFamily:
																						'Josefin Sans, sans-serif',
																					fontWeight: 500,
																					fontSize: 22,
																				}}>
																				Rs{' '}
																				{item.Airline_Code
																					? item.Fares[0].FareDetails[0]
																							.Total_Amount
																					: item.Fare.OfferedFare}
																			</TitleText>
																		)}

																		{loading ? (
																			<Skeleton
																				variant='text'
																				width='60px'
																				height='60px'
																			/>
																		) : (
																			<Box
																				onClick={() => {
																					history.push({
																						pathname: '/summaryflight',
																						state: {
																							OneflightData: item,
																							body: location.state.body,
																							IDTBO:
																								onewayflightdata &&
																								onewayflightdata.result &&
																								onewayflightdata.result
																									.Response &&
																								onewayflightdata.result.Response
																									.TraceId,
																							IDEtrav:
																								onewayflightdataEtrav &&
																								onewayflightdataEtrav.result &&
																								onewayflightdataEtrav.result
																									.Search_Key,
																						},
																					});
																				}}
																				style={{
																					color: 'white',
																					background: 'rgb(239, 51, 57)',
																					padding: '8px 25px',
																					borderRadius: 8,
																					marginLeft: 5,
																					cursor: 'pointer',
																					fontFamily:
																						'Josefin Sans, sans-serif',
																					fontWeight: 500,
																					boxShadow:
																						'3px 3px 12px -6px rgb(0 0 0 / 70%)',
																				}}>
																				<TitleText>Book Now</TitleText>
																			</Box>
																		)}
																	</Box>
																</Box>
																<Box
																	style={{
																		padding: '6px 10px',
																		background: '#f5f6f6',
																		borderBottomLeftRadius: 4,
																		borderBottomRightRadius: 4,
																		borderTop: '1px solid #e2e2e2',
																	}}
																	justifyContent='space-between'
																	alignItems='center'
																	display='flex'>
																	{/* <Box display='flex' alignItems='center'>
																	{loading ? (
																		<Skeleton
																			variant='text'
																			width='60px'
																			height='40px'
																		/>
																	) : (
																		<Box
																			style={{
																				padding: '2px 10px',
																				background: '#f56d6d',
																				borderRadius: 4,
																				boxShadow:
																					'3px 3px 12px -6px rgb(0 0 0 / 70%)',
																			}}>
																			<BodyText textStyle={{ color: 'white' }}>
																				{item.ResultFareType}
																			</BodyText>
																		</Box>
																	)}
																</Box> */}
																	{/* <Box
																	onClick={() => {
																		dispatch(toggleFlightModal(true));
																		dispatch(setFlightId(item.ResultIndex));
																		dispatch(
																			FlightFareRuleDispatch(
																				item.ResultIndex,
																				onewayflightdata &&
																					onewayflightdata.result &&
																					onewayflightdata.result.Response
																						.TraceId
																			)
																		);
																	}}
																	display='flex'
																	style={{ width: '40%' }}
																	justifyContent='space-between'>
																	<Box>
																		<BodyText
																			two
																			textStyle={{
																				fontFamily: 'Roboto Serif, sans-serif',
																				fontWeight: 700,
																			}}>
																			Free Meals
																		</BodyText>
																	</Box>
																	<Box display='flex' alignItems={'center'}>
																		<BodyText
																			two
																			textStyle={{
																				fontFamily: 'Roboto Serif, sans-serif',
																				fontWeight: 700,
																			}}>
																			Flight Details
																		</BodyText>
																		<ArrowDropDownIcon />
																	</Box>
																</Box> */}
																</Box>
															</>
														)
													) : (
														''
													);
												})}
											</InfiniteScroll>
										) : (
											<div
												style={{
													padding: '30px 15px',
													background: 'white',
													borderBottom: '1px solid #e6e6e6',
													textAlign: 'center',
												}}>
												<img src={flightnotfound}></img>
												<p style={{ fontSize: '24px', textAlign: 'center' }}>
													No Data Found
												</p>
											</div>
										)
									) : filterData && filterData.length > 0 ? (
										<InfiniteScroll
											dataLength={scrollVal}
											next={fetchMoreData}
											hasMore={hasMorefilterData}
											loader={
												<h4 style={{ textAlign: 'center' }}>Loading...</h4>
											}
											endMessage={
												<p style={{ textAlign: 'center' }}>
													<b>No More Data</b>
												</p>
											}>
											{filterData.map((item, index) => {
												return index < scrollVal ? (
													matches ? (
														<>
															<Box
																display='flex'
																style={{
																	// boxShadow: '3px 3px 16px -4px rgb(0 0 0 / 30%)',
																	padding: 8,
																}}
																justifyContent='space-between'
																alignItems='center'
																mt={'20px'}>
																<Box display='flex' alignItems='center'>
																	{loading ? (
																		<Skeleton
																			variant='circle'
																			width={40}
																			height={40}
																		/>
																	) : (
																		<img
																			src={`https://nitish.musafirbazar.com/static/media/${
																				item.AirlineCode
																					? item.AirlineCode
																					: item.Airline_Code
																					? item.Airline_Code
																					: item.AirlineCode
																			}.gif`}
																			width='50px'
																			height='25px'></img>
																	)}

																	<Box alignItems='center' ml={'5px'}>
																		<TitleText
																			two={matches ? false : true}
																			textStyle={{
																				fontFamily: 'Josefin Sans, sans-serif',
																				fontWeight: 500,
																				color: '#3c3c3c',
																				fontSize: matches ? 12 : '',
																			}}>
																			{loading ? (
																				<Skeleton variant='text' width='60px' />
																			) : item.Airline_Code ? (
																				item.Segments[0].Airline_Name
																			) : (
																				item.Segments[0]
																					.slice(0, 1)
																					.map((i) => {
																						return i.Airline.AirlineName;
																					})
																			)}
																		</TitleText>
																		{loading ? (
																			<Skeleton variant='text' width='60px' />
																		) : (
																			<BodyText
																				one
																				textStyle={{
																					fontFamily:
																						'Roboto Serif, sans-serif',
																					color: '#8f8f8f',
																					fontWeight: 600,
																				}}>
																				{item.Airline_Code
																					? item.Segments[0].Airline_Code
																					: item.Segments[0]
																							.slice(0, 1)
																							.map((i) => {
																								return i.Airline.AirlineCode;
																							})}
																				-
																				{item.Airline_Code
																					? item.Segments[0].Flight_Number
																					: item.Segments[0]
																							.slice(0, 1)
																							.map((i) => {
																								return i.Airline.FlightNumber;
																							})}
																			</BodyText>
																		)}
																	</Box>
																</Box>

																<Box alignItems='center' display='flex'>
																	{loading ? (
																		<Skeleton variant='text' width='60px' />
																	) : (
																		<TitleText
																			four={matches ? false : true}
																			textStyle={{
																				fontFamily: 'Josefin Sans, sans-serif',
																				fontWeight: 500,
																				fontSize: matches ? 14 : '',
																			}}>
																			Rs{' '}
																			{item.Airline_Code
																				? item.Fares[0].FareDetails[0]
																						.Total_Amount
																				: item.Fare.OfferedFare}
																		</TitleText>
																	)}

																	{/* <MoreVertIcon /> */}
																	{loading ? (
																		<Skeleton
																			variant='text'
																			width='60px'
																			height='60px'
																		/>
																	) : (
																		<Box
																			onClick={() => {
																				history.push({
																					pathname: '/summaryflight',
																					state: {
																						OneflightData: item,
																						body: location.state.body,
																						IDTBO:
																							onewayflightdata &&
																							onewayflightdata.result &&
																							onewayflightdata.result
																								.Response &&
																							onewayflightdata.result.Response
																								.TraceId,
																						IDEtrav:
																							onewayflightdataEtrav &&
																							onewayflightdataEtrav.result &&
																							onewayflightdataEtrav.result
																								.Search_Key,
																					},
																				});
																			}}
																			style={{
																				color: 'white',
																				marginLeft: 5,
																				background: 'rgb(239, 51, 57)',
																				padding: '8px 25px',
																				borderRadius: 8,
																				cursor: 'pointer',
																				fontFamily: 'Josefin Sans, sans-serif',
																				fontWeight: 500,
																				boxShadow:
																					'3px 3px 12px -6px rgb(0 0 0 / 70%)',
																			}}>
																			<TitleText
																				textStyle={{
																					fontSize: matches ? 14 : '',
																				}}>
																				Book Now
																			</TitleText>
																		</Box>
																	)}
																</Box>
															</Box>
															<Box
																display='flex'
																style={{
																	boxShadow:
																		'3px 3px 16px -4px rgb(0 0 0 / 30%)',
																	padding: 8,
																}}
																justifyContent='space-between'
																alignItems='center'>
																<Box>
																	{loading ? (
																		<Skeleton variant='text' width='60px' />
																	) : (
																		<TitleText
																			two
																			textStyle={{
																				fontFamily: 'Josefin Sans, sans-serif',
																				fontWeight: 500,
																			}}>
																			{item.Origin
																				? item.Origin
																				: item.FareRules[0].Origin}
																		</TitleText>
																	)}
																	{loading ? (
																		<Skeleton variant='text' width='60px' />
																	) : (
																		<TitleText two>
																			{item.Airline_Code
																				? item.Segments[0].Departure_DateTime.substr(
																						11,
																						5
																				  )
																				: item.Segments[0]
																						.slice(0, 1)
																						.map((i) => {
																							return i.Origin.DepTime.substr(
																								11,
																								5
																							);
																						})}
																		</TitleText>
																	)}
																</Box>
																<Box alignItems='center' textAlign='center'>
																	{loading ? (
																		<Skeleton variant='text' width='100px' />
																	) : (
																		<BodyText
																			two
																			textStyle={{
																				color: 'rgb(239, 51, 57)',
																				fontWeight: 700,
																				fontSize: 13,
																			}}>
																			{timeConvert(
																				item.Airline_Code
																					? item.Segments.length === 2
																						? Number(
																								convertH2M(
																									item.Segments.filter(
																										(i, index) => index === 0
																									).map((it) => it.Duration)[0]
																								)
																						  ) +
																						  Number(
																								convertH2M(
																									item.Segments.filter(
																										(i, index) => index === 1
																									).map((it) => it.Duration)[0]
																								)
																						  )
																						: item.Segments.length === 1
																						? Number(
																								convertH2M(
																									item.Segments.filter(
																										(i, index) => index === 0
																									).map((it) => it.Duration)[0]
																								)
																						  )
																						: ''
																					: item.Segments[0].length == 2
																					? Number(
																							item.Segments[0]
																								.filter(
																									(i, index) => index === 0
																								)
																								.map((it) => {
																									return it.Duration;
																								})
																					  ) +
																					  Number(
																							item.Segments[0]
																								.filter(
																									(i, index) => index === 1
																								)
																								.map((it) => {
																									return it.Duration;
																								})
																					  )
																					: item.Segments[0].length == 1
																					? item.Segments[0].map(
																							(i) => i.Duration
																					  )
																					: item.Segments[0].length == 3
																					? Number(
																							item.Segments[0]
																								.filter(
																									(i, index) => index === 0
																								)
																								.map((it) => {
																									return it.Duration;
																								})
																					  ) +
																					  Number(
																							item.Segments[0]
																								.filter(
																									(i, index) => index === 1
																								)
																								.map((it) => {
																									return it.Duration;
																								})
																					  ) +
																					  Number(
																							item.Segments[0]
																								.filter(
																									(i, index) => index === 2
																								)
																								.map((it) => {
																									return it.Duration;
																								})
																					  )
																					: ''
																			)}
																		</BodyText>
																	)}
																	{loading ? (
																		<Skeleton variant='text' width='60px' />
																	) : (
																		<BodyText
																			one
																			textStyle={{ color: '#8f8f8f' }}>
																			Non Stop
																		</BodyText>
																	)}
																</Box>
																<Box>
																	{loading ? (
																		<Skeleton variant='text' width='60px' />
																	) : (
																		<TitleText
																			two
																			textStyle={{
																				fontFamily: 'Josefin Sans, sans-serif',
																				fontWeight: 500,
																			}}>
																			{item.Airline_Code
																				? item.Segments.length === 1
																					? item.Segments.filter(
																							(i, index) => index === 0
																					  ).map((it) => {
																							return it.Destination;
																					  })
																					: item.Segments.length === 2
																					? item.Segments.filter(
																							(i, index) => index === 1
																					  ).map((it) => {
																							return it.Destination;
																					  })
																					: item.Segments.length === 3
																					? item.Segments.filter(
																							(i, index) => index === 2
																					  ).map((it) => {
																							return it.Destination;
																					  })
																					: ''
																				: item.Segments[0].length == 2
																				? item.Segments[0]
																						.filter((i, index) => index === 1)
																						.map((it) => {
																							return it.Destination.Airport
																								.AirportCode;
																						})
																				: item.Segments[0].length == 3
																				? item.Segments[0]
																						.filter((i, index) => index === 2)
																						.map((it) => {
																							return it.Destination.Airport
																								.AirportCode;
																						})
																				: item.Segments[0].length == 1
																				? item.Segments[0].map((it) => {
																						return it.Destination.Airport
																							.AirportCode;
																				  })
																				: ''}
																		</TitleText>
																	)}
																	{loading ? (
																		<Skeleton variant='text' width='60px' />
																	) : (
																		<TitleText two>
																			{item.Airline_Code
																				? item.Segments.length === 1
																					? item.Segments.filter(
																							(i, index) => index === 0
																					  ).map((it) => {
																							return it.Departure_DateTime.substr(
																								11,
																								5
																							);
																					  })
																					: item.Segments.length === 2
																					? item.Segments.filter(
																							(i, index) => index === 1
																					  ).map((it) => {
																							return it.Departure_DateTime.substr(
																								11,
																								5
																							);
																					  })
																					: item.Segments.length === 3
																					? item.Segments.filter(
																							(i, index) => index === 2
																					  ).map((it) => {
																							return it.Departure_DateTime.substr(
																								11,
																								5
																							);
																					  })
																					: ''
																				: item.Segments[0].length == 3
																				? item.Segments[0]
																						.filter((i, index) => index === 2)
																						.map((i) => {
																							return i.Destination.ArrTime.substr(
																								11,
																								5
																							);
																						})
																				: item.Segments[0].length == 2
																				? item.Segments[0]
																						.filter((i, index) => index === 1)
																						.map((i) => {
																							return i.Destination.ArrTime.substr(
																								11,
																								5
																							);
																						})
																				: item.Segments[0].length == 1
																				? item.Segments[0]
																						.filter((i, index) => index === 0)
																						.map((i) => {
																							return i.Destination.ArrTime.substr(
																								11,
																								5
																							);
																						})
																				: ''}
																		</TitleText>
																	)}
																</Box>
															</Box>
															<Box
																style={{
																	padding: '6px 10px',
																	background: '#f5f6f6',
																	borderBottomLeftRadius: 4,
																	borderBottomRightRadius: 4,
																	borderTop: '1px solid #e2e2e2',
																}}
																justifyContent='space-between'
																alignItems='center'
																display='flex'>
																<Box display='flex' alignItems='center'>
																	{loading ? (
																		<Skeleton
																			variant='text'
																			width='60px'
																			height='40px'
																		/>
																	) : (
																		<Box
																			style={{
																				padding: '2px 10px',
																				background: '#f56d6d',
																				borderRadius: 4,
																				boxShadow:
																					'3px 3px 12px -6px rgb(0 0 0 / 70%)',
																			}}>
																			{/* <BodyText>{item.ResultFareType}</BodyText> */}
																		</Box>
																	)}
																</Box>
																{/* <Box
																	onClick={() => {
																		dispatch(toggleFlightModal(true));
																		dispatch(setFlightId(item.ResultIndex));
																		dispatch(
																			FlightFareRuleDispatch(
																				item.ResultIndex,
																				onewayflightdata &&
																					onewayflightdata.result &&
																					onewayflightdata.result.Response
																						.TraceId
																			)
																		);
																	}}
																	display='flex'
																	style={{ width: '40%' }}
																	justifyContent='space-between'>
																	<Box>
																		<BodyText
																			two
																			textStyle={{
																				fontFamily: 'Roboto Serif, sans-serif',
																			}}>
																			Free Meals
																		</BodyText>
																	</Box>
																	<Box display='flex' alignItems={'center'}>
																		<BodyText
																			two
																			textStyle={{
																				fontFamily: 'Roboto Serif, sans-serif',
																			}}>
																			Flight Details
																		</BodyText>
																		<ArrowDropDownIcon />
																	</Box>
																</Box> */}
															</Box>
														</>
													) : (
														<>
															<Box
																display='flex'
																style={{
																	boxShadow:
																		'3px 3px 16px -4px rgb(0 0 0 / 30%)',
																	padding: 8,
																}}
																justifyContent='space-between'
																alignItems='center'
																mt={'20px'}>
																<Box display='flex' alignItems='center'>
																	{loading ? (
																		<Skeleton
																			variant='circle'
																			width={40}
																			height={40}
																		/>
																	) : (
																		<img
																			src={`https://nitish.musafirbazar.com/static/media/${
																				item.AirlineCode
																					? item.AirlineCode
																					: item.Airline_Code
																					? item.Airline_Code
																					: item.AirlineCode
																			}.gif`}
																			width='50px'
																			height='25px'></img>
																	)}

																	<Box alignItems='center' ml={'5px'}>
																		<TitleText
																			three
																			textStyle={{
																				fontFamily: 'Josefin Sans, sans-serif',
																				fontWeight: 500,
																				color: '#3c3c3c',
																			}}>
																			{loading ? (
																				<Skeleton variant='text' width='60px' />
																			) : item.Airline_Code ? (
																				item.Segments[0].Airline_Name
																			) : (
																				item.Segments[0]
																					.slice(0, 1)
																					.map((i) => {
																						return i.Airline.AirlineName;
																					})
																			)}
																		</TitleText>
																		{loading ? (
																			<Skeleton variant='text' width='60px' />
																		) : (
																			<BodyText
																				two
																				textStyle={{
																					fontFamily:
																						'Roboto Serif, sans-serif',
																					color: '#8f8f8f',
																					fontWeight: 600,
																				}}>
																				{item.Airline_Code
																					? item.Segments[0].Airline_Code
																					: item.Segments[0]
																							.slice(0, 1)
																							.map((i) => {
																								return i.Airline.AirlineCode;
																							})}
																				-
																				{item.Airline_Code
																					? item.Segments[0].Flight_Number
																					: item.Segments[0]
																							.slice(0, 1)
																							.map((i) => {
																								return i.Airline.FlightNumber;
																							})}
																			</BodyText>
																		)}
																	</Box>
																</Box>
																<Box>
																	{loading ? (
																		<Skeleton variant='text' width='60px' />
																	) : (
																		<TitleText
																			three
																			textStyle={{
																				fontFamily: 'Josefin Sans, sans-serif',
																				fontWeight: 500,
																			}}>
																			{item.Origin
																				? item.Origin
																				: item.FareRules[0].Origin}
																		</TitleText>
																	)}
																	{loading ? (
																		<Skeleton variant='text' width='60px' />
																	) : (
																		<TitleText three>
																			{item.Airline_Code
																				? item.Segments[0].Departure_DateTime.substr(
																						11,
																						5
																				  )
																				: item.Segments[0]
																						.slice(0, 1)
																						.map((i) => {
																							return i.Origin.DepTime.substr(
																								11,
																								5
																							);
																						})}
																			{/* {console.log(
																				item.Segments[0]
																					.slice(0, 1)
																					.map((i) => {
																						return i.Origin.DepTime.substr(
																							11,
																							2
																						);
																					}) > 2
																					? 'YES'
																					: 'NO'
																			)} */}
																		</TitleText>
																	)}
																</Box>
																<Box alignItems='center' textAlign='center'>
																	{loading ? (
																		<Skeleton variant='text' width='100px' />
																	) : (
																		<BodyText
																			three
																			textStyle={{
																				color: 'rgb(239, 51, 57)',
																				fontWeight: 700,
																				fontSize: 13,
																			}}>
																			{console.log(
																				'Duration',
																				// convertH2M(
																				item.Segments.length === 2
																					? item.Airline_Code
																						? item.Segments.filter(
																								(i, index) => index === 0
																						  ).map((it) => {
																								return it.Duration;
																						  })
																						: ''
																					: ''
																				// )
																			)}
																			{timeConvert(
																				item.Airline_Code
																					? item.Segments.length === 2
																						? Number(
																								convertH2M(
																									item.Segments.filter(
																										(i, index) => index === 0
																									).map((it) => it.Duration)[0]
																								)
																						  ) +
																						  Number(
																								convertH2M(
																									item.Segments.filter(
																										(i, index) => index === 1
																									).map((it) => it.Duration)[0]
																								)
																						  )
																						: item.Segments.length === 1
																						? Number(
																								convertH2M(
																									item.Segments.filter(
																										(i, index) => index === 0
																									).map((it) => it.Duration)[0]
																								)
																						  )
																						: ''
																					: item.Segments[0].length == 2
																					? Number(
																							item.Segments[0]
																								.filter(
																									(i, index) => index === 0
																								)
																								.map((it) => {
																									return it.Duration;
																								})
																					  ) +
																					  Number(
																							item.Segments[0]
																								.filter(
																									(i, index) => index === 1
																								)
																								.map((it) => {
																									return it.Duration;
																								})
																					  )
																					: item.Segments[0].length == 1
																					? item.Segments[0].map(
																							(i) => i.Duration
																					  )
																					: item.Segments[0].length == 3
																					? Number(
																							item.Segments[0]
																								.filter(
																									(i, index) => index === 0
																								)
																								.map((it) => {
																									return it.Duration;
																								})
																					  ) +
																					  Number(
																							item.Segments[0]
																								.filter(
																									(i, index) => index === 1
																								)
																								.map((it) => {
																									return it.Duration;
																								})
																					  ) +
																					  Number(
																							item.Segments[0]
																								.filter(
																									(i, index) => index === 2
																								)
																								.map((it) => {
																									return it.Duration;
																								})
																					  )
																					: ''
																			)}
																		</BodyText>
																	)}
																	{loading ? (
																		<Skeleton variant='text' width='60px' />
																	) : (
																		<BodyText
																			two
																			textStyle={{ color: '#8f8f8f' }}>
																			Non Stop
																		</BodyText>
																	)}
																</Box>
																<Box>
																	{loading ? (
																		<Skeleton variant='text' width='60px' />
																	) : (
																		<TitleText
																			three
																			textStyle={{
																				fontFamily: 'Josefin Sans, sans-serif',
																				fontWeight: 500,
																			}}>
																			{item.Airline_Code
																				? item.Segments.length === 1
																					? item.Segments.filter(
																							(i, index) => index === 0
																					  ).map((it) => {
																							return it.Destination;
																					  })
																					: item.Segments.length === 2
																					? item.Segments.filter(
																							(i, index) => index === 1
																					  ).map((it) => {
																							return it.Destination;
																					  })
																					: item.Segments.length === 3
																					? item.Segments.filter(
																							(i, index) => index === 2
																					  ).map((it) => {
																							return it.Destination;
																					  })
																					: ''
																				: item.Segments[0].length == 2
																				? item.Segments[0]
																						.filter((i, index) => index === 1)
																						.map((it) => {
																							return it.Destination.Airport
																								.AirportCode;
																						})
																				: item.Segments[0].length == 3
																				? item.Segments[0]
																						.filter((i, index) => index === 2)
																						.map((it) => {
																							return it.Destination.Airport
																								.AirportCode;
																						})
																				: item.Segments[0].length == 1
																				? item.Segments[0].map((it) => {
																						return it.Destination.Airport
																							.AirportCode;
																				  })
																				: ''}
																		</TitleText>
																	)}
																	{loading ? (
																		<Skeleton variant='text' width='60px' />
																	) : (
																		<TitleText three>
																			{item.Airline_Code
																				? item.Segments.length === 1
																					? item.Segments.filter(
																							(i, index) => index === 0
																					  ).map((it) => {
																							return it.Departure_DateTime.substr(
																								11,
																								5
																							);
																					  })
																					: item.Segments.length === 2
																					? item.Segments.filter(
																							(i, index) => index === 1
																					  ).map((it) => {
																							return it.Departure_DateTime.substr(
																								11,
																								5
																							);
																					  })
																					: item.Segments.length === 3
																					? item.Segments.filter(
																							(i, index) => index === 2
																					  ).map((it) => {
																							return it.Departure_DateTime.substr(
																								11,
																								5
																							);
																					  })
																					: ''
																				: item.Segments[0].length == 3
																				? item.Segments[0]
																						.filter((i, index) => index === 2)
																						.map((i) => {
																							return i.Destination.ArrTime.substr(
																								11,
																								5
																							);
																						})
																				: item.Segments[0].length == 2
																				? item.Segments[0]
																						.filter((i, index) => index === 1)
																						.map((i) => {
																							return i.Destination.ArrTime.substr(
																								11,
																								5
																							);
																						})
																				: item.Segments[0].length == 1
																				? item.Segments[0]
																						.filter((i, index) => index === 0)
																						.map((i) => {
																							return i.Destination.ArrTime.substr(
																								11,
																								5
																							);
																						})
																				: ''}
																		</TitleText>
																	)}
																</Box>
																<Box alignItems='center' display='flex'>
																	{loading ? (
																		<Skeleton variant='text' width='60px' />
																	) : (
																		<TitleText
																			textStyle={{
																				fontFamily: 'Josefin Sans, sans-serif',
																				fontWeight: 500,
																				fontSize: 22,
																			}}>
																			₹{' '}
																			{item.Airline_Code
																				? Math.round(
																						item.Fares[0].FareDetails[0]
																							.Total_Amount
																				  )
																				: Math.round(item.Fare.PublishedFare)}
																		</TitleText>
																	)}

																	{loading ? (
																		<Skeleton
																			variant='text'
																			width='60px'
																			height='60px'
																		/>
																	) : (
																		<Box
																			onClick={() => {
																				history.push({
																					pathname: '/summaryflight',
																					state: {
																						OneflightData: item,
																						body: location.state.body,
																						IDTBO:
																							onewayflightdata &&
																							onewayflightdata.result &&
																							onewayflightdata.result
																								.Response &&
																							onewayflightdata.result.Response
																								.TraceId,
																						IDEtrav:
																							onewayflightdataEtrav &&
																							onewayflightdataEtrav.result &&
																							onewayflightdataEtrav.result
																								.Search_Key,
																					},
																				});
																			}}
																			style={{
																				color: 'white',
																				background: 'rgb(239, 51, 57)',
																				padding: '8px 25px',
																				borderRadius: 8,
																				marginLeft: 5,
																				cursor: 'pointer',
																				fontFamily: 'Josefin Sans, sans-serif',
																				fontWeight: 500,
																				boxShadow:
																					'3px 3px 12px -6px rgb(0 0 0 / 70%)',
																			}}>
																			<TitleText>Book Now</TitleText>
																		</Box>
																	)}
																</Box>
															</Box>
															<Box
																style={{
																	padding: '6px 10px',
																	background: '#f5f6f6',
																	borderBottomLeftRadius: 4,
																	borderBottomRightRadius: 4,
																	borderTop: '1px solid #e2e2e2',
																}}
																justifyContent='space-between'
																alignItems='center'
																display='flex'>
																<Box display='flex' alignItems='center'>
																	{loading ? (
																		<Skeleton
																			variant='text'
																			width='60px'
																			height='40px'
																		/>
																	) : (
																		<Box
																			style={{
																				padding: '2px 10px',
																				background: item.AirlineCode
																					? item.FareClassification.Color
																					: '#f56d6d',
																				borderRadius: 4,
																				boxShadow:
																					'3px 3px 12px -6px rgb(0 0 0 / 70%)',
																			}}>
																			<BodyText textStyle={{ color: 'black' }}>
																				{/* {item.ResultFareType} */}
																				{item.AirlineCode
																					? item.FareClassification.Type
																					: 'Etrav'}
																			</BodyText>
																		</Box>
																	)}
																</Box>
																<Box
																	onClick={() => {
																		dispatch(toggleFlightModal(true));
																		dispatch(
																			setFlightId(
																				item.Airline_Code
																					? item.Flight_Id
																					: item.ResultIndex
																			)
																		);

																		if (item.Airline_Code) {
																			dispatch(
																				FlightFareRuleEtravDispatch(
																					onewayflightdataEtrav &&
																						onewayflightdataEtrav.result &&
																						onewayflightdataEtrav.result
																							.Search_Key,
																					item.Flight_Key,
																					item.Fares[0].Fare_Id
																				)
																			);
																		} else {
																			dispatch(
																				FlightFareRuleDispatch(
																					item.ResultIndex,
																					onewayflightdata &&
																						onewayflightdata.result &&
																						onewayflightdata.result.Response
																							.TraceId
																				)
																			);
																		}
																	}}
																	display='flex'
																	justifyContent='space-between'>
																	{/* <Box>
																		<BodyText
																			two
																			textStyle={{
																				fontFamily: 'Roboto Serif, sans-serif',
																				fontWeight: 700,
																			}}>
																			Free Meals
																		</BodyText>
																	</Box> */}
																	<Box></Box>
																	<Box
																		display='flex'
																		alignItems={'center'}
																		style={{ cursor: 'pointer' }}>
																		<p
																			textStyle={{
																				fontFamily: 'Roboto Serif, sans-serif',
																				fontSize: 10,
																			}}>
																			Flight Details
																		</p>
																		<ArrowDropDownIcon />
																	</Box>
																</Box>
															</Box>
														</>
													)
												) : (
													''
												);
											})}
										</InfiniteScroll>
									) : (
										<>
											<div>Sorry No Data Found</div>
										</>
										// filter Ending
										// onewayflightdata &&
										// onewayflightdata.result &&
										// onewayflightdata.result.Response &&
										// onewayflightdata.result.Response.Results &&
										// onewayflightdata.result.Response.Results[0].length > 0 &&
										// onewayflightdata.result.Response.Results[0].map(
										// 	(item, index) => {
										// 		return (
										// <>
										// 	<Box
										// 		display='flex'
										// 		style={{
										// 			boxShadow: '3px 3px 16px -4px rgb(0 0 0 / 30%)',
										// 			padding: 8,
										// 		}}
										// 		justifyContent='space-between'
										// 		mt={'20px'}>
										// 		<Box display='flex' alignItems='center'>
										// 			<img
										// 				src={`https://nitish.musafirbazar.com/static/media/${item.Segments[0]
										// 					.slice(0, 1)
										// 					.map((i) => {
										// 						return i.Airline.AirlineCode;
										// 					})}.gif`}
										// 				width='50px'
										// 				height='25px'></img>
										// 			<Box alignItems='center' ml={'5px'}>
										// 				<TitleText two>
										// 					{item.Segments[0].map((i) => {
										// 						return i.Airline.AirlineName;
										// 					})}
										// 				</TitleText>
										// 				<BodyText two>
										// 					{item.Segments[0].slice(0, 1).map((i) => {
										// 						return i.Airline.AirlineCode;
										// 					})}
										// 					-
										// 					{item.Segments[0].slice(0, 1).map((i) => {
										// 						return i.Airline.FlightNumber;
										// 					})}
										// 				</BodyText>
										// 			</Box>
										// 		</Box>

										// 		<Box>
										// 			<TitleText two>
										// 				{item.FareRules[0].Origin}
										// 			</TitleText>
										// 			<TitleText two>
										// 				{item.Segments[0].slice(0, 1).map((i) => {
										// 					return i.Origin.DepTime.substr(11, 5);
										// 				})}
										// 			</TitleText>
										// 		</Box>
										// 		<Box alignItems='center' textAlign='center'>
										// 			<TitleText two>
										// 				{console.log(item.Segments[0].slice(0, 2))}
										// 			</TitleText>
										// 			<TitleText one>Non Stop</TitleText>
										// 		</Box>
										// 		<Box>
										// 			<TitleText two>
										// 				{item.FareRules[0].Destination}
										// 			</TitleText>
										// 			<TitleText two>
										// 				{item.Segments[0].slice(0, 1).map((i) => {
										// 					return i.Destination.ArrTime.substr(11, 5);
										// 				})}
										// 			</TitleText>
										// 		</Box>
										// 		<Box alignItems='center' display='flex'>
										// 			<TitleText>
										// 				Rs {item.Fare.OfferedFare}
										// 			</TitleText>
										// 			{/* <MoreVertIcon /> */}
										// 			<Box
										// 				onClick={() => {
										// 					history.push({
										// 						pathname: '/flightsummary',
										// 						state: {
										// 							OneflightData: item,
										// 							body: location.state.body,
										// 						},
										// 					});
										// 				}}
										// 				style={{
										// 					color: 'white',
										// 					background: 'rgb(239, 51, 57)',
										// 					padding: '8px 25px',
										// 					borderRadius: 8,
										// 					marginLeft: 5,
										// 					boxShadow:
										// 						'3px 3px 12px -6px rgb(0 0 0 / 70%)',
										// 				}}>
										// 				<TitleText>Book Now</TitleText>
										// 			</Box>
										// 		</Box>
										// 	</Box>
										// 	<Box
										// 		style={{
										// 			padding: '6px 10px',
										// 			background: '#f5f6f6',
										// 			borderBottomLeftRadius: 4,
										// 			borderBottomRightRadius: 4,
										// 			borderTop: '1px solid #e2e2e2',
										// 		}}
										// 		justifyContent='space-between'
										// 		alignItems='center'
										// 		display='flex'>
										// 		<Box display='flex' alignItems='center'>
										// 			<TitleText>Routes:</TitleText>
										// 			<Box
										// 				style={{
										// 					padding: '2px 10px',
										// 					background: '#f56d6d',
										// 					borderRadius: 4,
										// 					boxShadow:
										// 						'3px 3px 12px -6px rgb(0 0 0 / 70%)',
										// 				}}>
										// 				<BodyText textStyle={{ color: 'white' }}>
										// 					{item.ResultFareType}
										// 				</BodyText>
										// 			</Box>
										// 		</Box>
										// 		<Box
										// 			onClick={() => {
										// 				dispatch(toggleFlightModal(true));
										// 				dispatch(setFlightId(item.ResultIndex));
										// 				dispatch(
										// 					FlightFareRuleDispatch(
										// 						item.ResultIndex,
										// 						onewayflightdata &&
										// 							onewayflightdata.result &&
										// 							onewayflightdata.result.Response.TraceId
										// 					)
										// 				);
										// 			}}
										// 			display='flex'
										// 			style={{ width: '40%' }}
										// 			justifyContent='space-between'>
										// 			<Box display='flex'>
										// 				<TitleText two>Flight Details</TitleText>
										// 				<ArrowDropDownIcon />
										// 			</Box>
										// 		</Box>
										// 	</Box>
										// </>
										// );
										// }
										// )
									)}
								</Grid>
							</Grid>
						</Grid>
					</Grid>
				</Container>
			</Box>
			<FlightDetailModal />
			<Drawers />
			<Login />
			<ErrorModal />
		</>
	);
};

export default OneWay;
